import type { CalculateAmountProps } from "./OurCompensationTable.d";

const standardFeePercentage = 35;
const legalFeePercentage = 50;

const formatAmount = (amount: number) => amount.toFixed(2).replace(/\.00$/, '');

const calculateAmount = (amount: CalculateAmountProps["amount"], type?: CalculateAmountProps["type"]) => {

  const calculate = () => {
    switch (type) {
      case "standardFee":
        return amount * standardFeePercentage / 100;
      case "standardCompensation":
        return amount * (100 - standardFeePercentage) / 100;
      case "legalFee":
        return amount * legalFeePercentage / 100;
      case "legalCompensation":
        return amount * (100 - legalFeePercentage) / 100;
      default:
        return amount;
    }
  }

  const formattedAmount = formatAmount(Number(calculate()));

  return `${formattedAmount} €`;
}

export { calculateAmount };
